import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { compareCompaniesAPI, compareTeamsAPI, compareUsersAPI, compareValidationsAPI, countValidationsAPI, countLiveUpdateAPI, getOverview, getAvgReportingTime  } from '../../config/config'
import {CompareValues, CompareValueRes, CountValues, CountValueRes, AvgReportingTime} from '../reducers/dashboard.reducer';


// Action types
export const GET_OVERVIEW_REQUEST = 'GET_OVERVIEW_REQUEST';
export const GET_OVERVIEW_SUCCESS = 'GET_OVERVIEW_SUCCESS';
export const GET_OVERVIEW_FAILURE = 'GET_OVERVIEW_FAILURE';

export const GET_COMPARE_COMPANIES_REQUEST = 'GET_COMPARE_COMPANIES_REQUEST';
export const GET_COMPARE_COMPANIES_SUCCESS = 'GET_COMPARE_COMPANIES_SUCCESS';
export const GET_COMPARE_COMPANIES_FAILURE = 'GET_COMPARE_COMPANIES_FAILURE';

export const GET_COMPARE_TEAMS_REQUEST = 'GET_COMPARE_TEAMS_REQUEST';
export const GET_COMPARE_TEAMS_SUCCESS = 'GET_COMPARE_TEAMS_SUCCESS';
export const GET_COMPARE_TEAMS_FAILURE = 'GET_COMPARE_TEAMS_FAILURE';

export const GET_COMPARE_USERS_REQUEST = 'GET_COMPARE_USERS_REQUEST';
export const GET_COMPARE_USERS_SUCCESS = 'GET_COMPARE_USERS_SUCCESS';
export const GET_COMPARE_USERS_FAILURE = 'GET_COMPARE_USERS_FAILURE';

export const GET_COMPARE_VALIDATIONS_REQUEST = 'GET_COMPARE_VALIDATIONS_REQUEST';
export const GET_COMPARE_VALIDATIONS_SUCCESS = 'GET_COMPARE_VALIDATIONS_SUCCESS';
export const GET_COMPARE_VALIDATIONS_FAILURE = 'GET_COMPARE_VALIDATIONS_FAILURE';

export const GET_COUNT_VALIDATIONS_REQUEST = 'GET_COUNT_VALIDATIONS_REQUEST';
export const GET_COUNT_VALIDATIONS_SUCCESS = 'GET_COUNT_VALIDATIONS_SUCCESS';
export const GET_COUNT_VALIDATIONS_FAILURE = 'GET_COUNT_VALIDATIONS_FAILURE';

export const GET_COUNT_LIVEUPDATE_REQUEST = 'GET_COUNT_LIVEUPDATE_REQUEST';
export const GET_COUNT_LIVEUPDATE_SUCCESS = 'GET_COUNT_LIVEUPDATE_SUCCESS';
export const GET_COUNT_LIVEUPDATE_FAILURE = 'GET_COUNT_LIVEUPDATE_FAILURE';

export const GET_AVG_REPORTING_TIME_REQUEST = 'GET_AVG_REPORTING_TIME_REQUEST';
export const GET_AVG_REPORTING_TIME_SUCCESS = 'GET_AVG_REPORTING_TIME_SUCCESS';
export const GET_AVG_REPORTING_TIME_FAILURE = 'GET_AVG_REPORTING_TIME_FAILURE';

export const RESET_COMPARE_COMPANIES_STATE = 'RESET_COMPARE_COMPANIES_STATE'
export const RESET_COMPARE_TEAMS_STATE = 'RESET_COMPARE_TEAMS_STATE'
export const RESET_COMPARE_USERS_STATE = 'RESET_COMPARE_USERS_STATE'
export const RESET_COMPARE_VALIDATIONS_STATE = 'RESET_COMPARE_VALIDATIONS_STATE'
export const RESET_COUNT_VALIDATIONS_STATE = 'RESET_COUNT_VALIDATIONS_STATE'
export const RESET_COUNT_LIVEUPDATE_STATE = 'RESET_COUNT_LIVEUPDATE_STATE'

interface GetOverviewRequest extends Action<typeof GET_OVERVIEW_REQUEST> { }
interface GetOverviewSuccess extends Action<typeof GET_OVERVIEW_SUCCESS> {
  payload: any
}
interface GetOverviewFailure extends Action<typeof GET_OVERVIEW_FAILURE> {
  payload: string
}

interface GetCompareCompaniesRequest extends Action<typeof GET_COMPARE_COMPANIES_REQUEST> { }
interface GetCompareCompaniesSuccess extends Action<typeof GET_COMPARE_COMPANIES_SUCCESS> {
  payload: CompareValueRes
}
interface GetCompareCompaniesFailure extends Action<typeof GET_COMPARE_COMPANIES_FAILURE> {
  payload: string
}

interface GetAvgReportingTimeRequest extends Action<typeof GET_AVG_REPORTING_TIME_REQUEST> { }
interface GetAvgReportingTimeSuccess extends Action<typeof GET_AVG_REPORTING_TIME_SUCCESS> {
  payload: AvgReportingTime
}
interface GetAvgReportingTimeFailure extends Action<typeof GET_AVG_REPORTING_TIME_FAILURE> {
  payload: string
}

interface ResetCompareCompaniesState extends Action<typeof RESET_COMPARE_COMPANIES_STATE> {}

interface GetCompareTeamsRequest extends Action<typeof GET_COMPARE_TEAMS_REQUEST> { }
interface GetCompareTeamsSuccess extends Action<typeof GET_COMPARE_TEAMS_SUCCESS> {
  payload: CompareValueRes
}
interface GetCompareTeamsFailure extends Action<typeof GET_COMPARE_TEAMS_FAILURE> {
  payload: string
}

interface ResetCompareTeamsState extends Action<typeof RESET_COMPARE_TEAMS_STATE> {}

interface GetCompareUsersRequest extends Action<typeof GET_COMPARE_USERS_REQUEST> { }
interface GetCompareUsersSuccess extends Action<typeof GET_COMPARE_USERS_SUCCESS> {
  payload: CompareValueRes
}
interface GetCompareUsersFailure extends Action<typeof GET_COMPARE_USERS_FAILURE> {
  payload: string
}

interface ResetCompareUsersState extends Action<typeof RESET_COMPARE_USERS_STATE> {}

interface GetCompareValidationsRequest extends Action<typeof GET_COMPARE_VALIDATIONS_REQUEST> { }
interface GetCompareValidationsSuccess extends Action<typeof GET_COMPARE_VALIDATIONS_SUCCESS> {
  payload: CompareValueRes
}
interface GetCompareValidationsFailure extends Action<typeof GET_COMPARE_VALIDATIONS_FAILURE> {
  payload: string
}

interface ResetCompareValidationsState extends Action<typeof RESET_COMPARE_VALIDATIONS_STATE> {}

interface GetCountValidationsRequest extends Action<typeof GET_COUNT_VALIDATIONS_REQUEST> { }
interface GetCountValidationsSuccess extends Action<typeof GET_COUNT_VALIDATIONS_SUCCESS> {
  payload: CountValueRes
}
interface GetCountValidationsFailure extends Action<typeof GET_COUNT_VALIDATIONS_FAILURE> {
  payload: string
}

interface ResetCountValidationsState extends Action<typeof RESET_COUNT_VALIDATIONS_STATE> {}

interface GetCountLiveUpdateRequest extends Action<typeof GET_COUNT_LIVEUPDATE_REQUEST> { }
interface GetCountLiveUpdateSuccess extends Action<typeof GET_COUNT_LIVEUPDATE_SUCCESS> {
  payload: CountValueRes
}
interface GetCountLiveUpdateFailure extends Action<typeof GET_COUNT_LIVEUPDATE_FAILURE> {
  payload: string
}

interface ResetCountLiveUpdateState extends Action<typeof RESET_COUNT_LIVEUPDATE_STATE> {}

export type ActionTypes = GetCompareCompaniesRequest | GetCompareCompaniesSuccess | GetCompareCompaniesFailure
  | ResetCompareCompaniesState | GetCompareTeamsRequest | GetCompareTeamsSuccess | GetCompareTeamsFailure | ResetCompareTeamsState
  | GetCompareUsersRequest | GetCompareUsersSuccess | GetCompareUsersFailure | ResetCompareUsersState
  | GetCompareValidationsRequest | GetCompareValidationsSuccess | GetCompareValidationsFailure | ResetCompareValidationsState
  | GetCountValidationsRequest | GetCountValidationsSuccess | GetCountValidationsFailure | ResetCountValidationsState
  | GetCountLiveUpdateRequest | GetCountLiveUpdateSuccess | GetCountLiveUpdateFailure | ResetCountLiveUpdateState 
  | GetOverviewRequest | GetOverviewSuccess | GetOverviewFailure | GetAvgReportingTimeRequest | GetAvgReportingTimeSuccess |GetAvgReportingTimeFailure

// Action creators
const getOverviewRequest = (): GetOverviewRequest => ({ type: GET_OVERVIEW_REQUEST });
const getOverviewSuccess = (data: any): GetOverviewSuccess => ({ type: GET_OVERVIEW_SUCCESS, payload: data });
const getOverviewFailure = (error: string): GetOverviewFailure => ({ type: GET_OVERVIEW_FAILURE, payload: error });

const getCompareCompaniesRequest = (): GetCompareCompaniesRequest => ({ type: GET_COMPARE_COMPANIES_REQUEST });
const getCompareCompaniesSuccess = (data: CompareValueRes): GetCompareCompaniesSuccess => ({ type: GET_COMPARE_COMPANIES_SUCCESS, payload: data });
const getCompareCompaniesFailure = (error: string): GetCompareCompaniesFailure => ({ type: GET_COMPARE_COMPANIES_FAILURE, payload: error });

const getAvgReportingTimeRequest = (): GetAvgReportingTimeRequest => ({ type: GET_AVG_REPORTING_TIME_REQUEST });
const getAvgReportingTimeSuccess = (data: AvgReportingTime): GetAvgReportingTimeSuccess => ({ type: GET_AVG_REPORTING_TIME_SUCCESS, payload: data });
const getAvgReportingTimeFailure = (error: string): GetAvgReportingTimeFailure => ({ type: GET_AVG_REPORTING_TIME_FAILURE, payload: error });

const resetCompareCompaniesState = (): ResetCompareCompaniesState => ({type:RESET_COMPARE_COMPANIES_STATE})

const getCompareTeamsRequest = (): GetCompareTeamsRequest => ({ type: GET_COMPARE_TEAMS_REQUEST });
const getCompareTeamsSuccess = (data: CompareValueRes): GetCompareTeamsSuccess => ({ type: GET_COMPARE_TEAMS_SUCCESS, payload: data });
const getCompareTeamsFailure = (error: string): GetCompareTeamsFailure => ({ type: GET_COMPARE_TEAMS_FAILURE, payload: error });

const resetCompareTeamsState = (): ResetCompareTeamsState => ({type:RESET_COMPARE_TEAMS_STATE})

const getCompareUsersRequest = (): GetCompareUsersRequest => ({ type: GET_COMPARE_USERS_REQUEST });
const getCompareUsersSuccess = (data: CompareValueRes): GetCompareUsersSuccess => ({ type: GET_COMPARE_USERS_SUCCESS, payload: data });
const getCompareUsersFailure = (error: string): GetCompareUsersFailure => ({ type: GET_COMPARE_USERS_FAILURE, payload: error });

const resetCompareUsersState = (): ResetCompareUsersState => ({type:RESET_COMPARE_USERS_STATE})

const getCompareValidationsRequest = (): GetCompareValidationsRequest => ({ type: GET_COMPARE_VALIDATIONS_REQUEST });
const getCompareValidationsSuccess = (data: CompareValueRes): GetCompareValidationsSuccess => ({ type: GET_COMPARE_VALIDATIONS_SUCCESS, payload: data });
const getCompareValidationsFailure = (error: string): GetCompareValidationsFailure => ({ type: GET_COMPARE_VALIDATIONS_FAILURE, payload: error });

const resetCompareValidationsState = (): ResetCompareValidationsState => ({type:RESET_COMPARE_VALIDATIONS_STATE})

const getCountValidationsRequest = (): GetCountValidationsRequest => ({ type: GET_COUNT_VALIDATIONS_REQUEST });
const getCountValidationsSuccess = (data: CountValueRes): GetCountValidationsSuccess => ({ type: GET_COUNT_VALIDATIONS_SUCCESS, payload: data });
const getCountValidationsFailure = (error: string): GetCountValidationsFailure => ({ type: GET_COUNT_VALIDATIONS_FAILURE, payload: error });

const resetCountValidationsState = (): ResetCountValidationsState => ({type:RESET_COUNT_VALIDATIONS_STATE})

const getCountLiveUpdateRequest = (): GetCountLiveUpdateRequest => ({ type: GET_COUNT_LIVEUPDATE_REQUEST });
const getCountLiveUpdateSuccess = (data: CountValueRes): GetCountLiveUpdateSuccess => ({ type: GET_COUNT_LIVEUPDATE_SUCCESS, payload: data });
const getCountLiveUpdateFailure = (error: string): GetCountLiveUpdateFailure => ({ type: GET_COUNT_LIVEUPDATE_FAILURE, payload: error });

const resetCountLiveUpdateState = (): ResetCountLiveUpdateState => ({type:RESET_COUNT_LIVEUPDATE_STATE})


// Async action creators
const getDashboardOverview = (params?: any) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getOverviewRequest());
      let query = ''
      if(params){
          Object.keys(params)?.map((key, i)=>{
              if(i===0){
                  query = `?${key}=${params[key]}`
              }else{
                  query = query + `&${key}=${params[key]}`
              }
          })
      }
     
      const response = await getOverview(query)
   
      dispatch(getOverviewSuccess(response?.data || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getOverviewFailure(error.message));
    }
  };
};

const getCompareCompanies = (data: CompareValues) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCompareCompaniesRequest());
      const response = await compareCompaniesAPI(data)
      console.log(response)
      dispatch(getCompareCompaniesSuccess(response?.data || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompareCompaniesFailure(error.message));
    }
  };
};

const resetCompareCompanies = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetCompareCompaniesState())
  };
}

const getCompareTeams = (data: CompareValues) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCompareTeamsRequest());
      const response = await compareTeamsAPI(data)
      console.log(response)
      dispatch(getCompareTeamsSuccess(response?.data || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompareTeamsFailure(error.message));
    }
  };
};

const resetCompareTeams = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetCompareTeamsState())
  };
}

const getCompareUsers = (data: CompareValues) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCompareUsersRequest());
      const response = await compareUsersAPI(data)
      console.log(response)
      dispatch(getCompareUsersSuccess(response?.data || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompareUsersFailure(error.message));
    }
  };
};

const resetCompareUsers = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetCompareUsersState())
  };
}

const getCompareValidations = (data: CompareValues) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCompareValidationsRequest());
      const response = await compareValidationsAPI(data)
      console.log(response)
      dispatch(getCompareValidationsSuccess(response?.data || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCompareValidationsFailure(error.message));
    }
  };
};

const resetCompareValidations = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetCompareValidationsState())
  };
}

const getCountValidations = (data: CountValues) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCountValidationsRequest());
      const response = await countValidationsAPI(data)
      console.log(response)
      dispatch(getCountValidationsSuccess(response?.data || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCountValidationsFailure(error.message));
    }
  };
};

const resetCountValidations = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetCountValidationsState())
  };
}

const getCountLiveUpdate = (data: CountValues) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getCountLiveUpdateRequest());
      const response = await countLiveUpdateAPI(data)
      console.log(response)
      dispatch(getCountLiveUpdateSuccess(response?.data?.users || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getCountLiveUpdateFailure(error.message));
    }
  };
};

const resetCountLiveUpdate = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetCountLiveUpdateState())
  };
}


const getAvgReportTime = (data: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getAvgReportingTimeRequest());
      const response = await getAvgReportingTime(data)
      console.log(response)
      dispatch(getAvgReportingTimeSuccess(response?.data || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getAvgReportingTimeSuccess(error.message));
    }
  };
};

const actions = {
  getCompareCompanies,
  resetCompareCompanies,
  getCompareTeams,
  resetCompareTeams,
  getCompareUsers,
  resetCompareUsers,
  getCompareValidations,
  resetCompareValidations,
  getCountValidations,
  resetCountValidations,
  getCountLiveUpdate,
  resetCountLiveUpdate,
  getDashboardOverview,
  getAvgReportTime
}

export default actions
